export const documentConverter = {
  toFirestore: ({ id: _id, ...data }) => {
    if (data.offlineSigned) {
      return data
    }
    const { firstParty, counterParties } = data
    return {
      ...data,
      firstParty: convertPartyToFirestore(firstParty),
      counterParties: convertPartiesArrayToFirestore(counterParties)
    }
  },
  fromFirestore: (snapshot) => {
    const data = snapshot.data()
    if (data.offlineSigned) {
      return data
    }
    const { firstParty, counterParties } = data
    return {
      ...data,
      firstParty: convertPartyFromFirestore(firstParty),
      counterParties: convertPartiesArrayFromFirestore(counterParties)
    }
  }
}

function convertPartiesArrayFromFirestore(parties) {
  const results = objectToArray(parties).map(convertPartyFromFirestore)
  return results
}

function convertPartyFromFirestore({
  signatories: signatoriesObject,
  ...party
}) {
  const signatories = objectToArray(signatoriesObject)
  return {
    ...party,
    signatories
  }
}

function objectToArray(theObject) {
  return Object.values(theObject)
    .sort(({ order: a }, { order: b }) => a - b)
    .map(({ order, ...data }) => data)
}

function convertPartyToFirestore({ signatories, ...party }) {
  return {
    ...party,
    signatories: signatories.reduce(
      (acc, signatory, index) => ({
        ...acc,
        [emailKey(signatory.email)]: { order: index, ...signatory }
      }),
      {}
    )
  }
}

function convertPartiesArrayToFirestore(parties) {
  return parties.reduce(
    (acc, party, index) => ({
      ...acc,
      [index]: { ...convertPartyToFirestore(party), order: index }
    }),
    {}
  )
}

export function emailKey(email) {
  return email.replace('.', '_')
}
